import { gql } from '@apollo/client';

export const UPDATE_ATTENDEES = gql`
  mutation updateAttendees($inputs: [UpdateAttendeesInput!]!) {
    updateAttendees(inputs: $inputs) {
      id
    }
  }
`;
